import React from "react";
import { BookOpen, Sparkles, UserRound } from "lucide-react";
import { MarkdownMessage } from "@/components/MarkdownMessage";

export const PlayerChat = ({ chat }) => (
  <section className="bg-[#0B1437] p-5 text-slate-100 sm:p-8" data-testid="player-step-chat">
    <p className="text-[10px] uppercase tracking-[0.2em] text-accent-blue-light">{chat.agent_name} · {chat.department}</p>
    {chat.starter_title && (
      <p className="mt-2 inline-flex items-center gap-1.5 border border-white/15 px-2 py-1 text-[11px] text-slate-300">
        <Sparkles className="h-3 w-3" /> Iniciador: {chat.starter_title}
      </p>
    )}
    <div className="mt-6 space-y-6">
      {chat.messages.map((m, i) => (m.role === "user" ? <UserMsg key={`u-${i}`} m={m} /> : <AgentMsg key={`a-${i}`} m={m} />))}
    </div>
  </section>
);

const UserMsg = ({ m }) => (
  <div className="flex justify-end">
    <div className="max-w-[85%] border border-white/10 bg-white/5 p-4 text-sm text-slate-200">
      <p className="mb-1 flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] text-slate-400"><UserRound className="h-3 w-3" /> Usuario</p>
      {m.content}
    </div>
  </div>
);

const AgentMsg = ({ m }) => (
  <div className="max-w-[92%] text-[15px] leading-[1.75]">
    <MarkdownMessage>{m.content}</MarkdownMessage>
    {!!m.citations?.length && (
      <div className="mt-3 flex flex-wrap gap-2" data-testid="player-citations">
        {m.citations.map((c) => (
          <span key={`${c.filename}-${c.chunk_index}`} className="inline-flex items-center gap-1 border border-accent-blue/40 bg-accent-blue/10 px-2 py-1 text-[11px] text-accent-blue-light">
            <BookOpen className="h-3 w-3" /> {c.filename.replace(/\.txt$/, "")}
          </span>
        ))}
      </div>
    )}
  </div>
);
